import '../accordion/css.js';
import '../contextmenu/css.js';
import '../datatable/css.js';
import '../docker/css.js';
import '../doubleclick/css.js';
import '../draggable/css.js';
import '../droppable/css.js';
import '../inlineedit/css.js';
import '../layout/css.js';
import '../menu/css.js';
import '../pager/css.js';
import '../resizable/css.js';
import '../rightclick/css.js';
import '../select/css.js';
import '../sortable/css.js';
import '../tabs/css.js';
import '../tree/css.js';
import '../utilities/css.js';
import '../window/css.js';
